export const MONITORING_EXTRA_FIELDS = {
    2: {
        additions: []
    },

    3: {
        inheritsFrom: 2,
        additions: []
    },

    4: {
        inheritsFrom: 3,
        additions: [
            // Tambah kolom khusus Mon4 di sini nanti
        ]
    },

    5: {
        inheritsFrom: 4,
        additions: [
            // Tambah kolom khusus Mon5 di sini nanti (misal: DetailPerSeeds)
        ]
    },
    6: {
        inheritsFrom: 5,
        additions: [
            // Tambah kolom khusus Mon6 di sini nanti (misal: DetailPerSeeds, etc.)
        ]
    },
}
